import { i18n } from '@/locales';
/**
 * 추가 할증 타입
 * https://www.notion.so/barogohq/90cd5756ca13432286525e6aa333c395?v=95a97034e7674e4b99cc12cf263fc0b5&p=1ff8a71f443444818c1c7872ff29af68&pm=s
 */
const lc = 'surcharge_type.';
export default {
    // 기상
    WEATHER: {
        value: 'WEATHER',
        text: i18n.t(`${lc}weather`),
    },
    // 휴일
    HOLIDAY: {
        value: 'HOLIDAY',
        text: i18n.t(`${lc}holiday`),
    },
    // 배달폭주
    BUSY: {
        value: 'BUSY',
        text: i18n.t(`${lc}busy`),
    },
    // 심야
    LATE_NIGHT: {
        value: 'LATE_NIGHT',
        text: i18n.t(`${lc}late_night`),
    },
    // 기타
    ETC: {
        value: 'ETC',
        text: i18n.t(`${lc}etc`),
    },
    // 없음
    NONE: {
        value: 'NONE',
        text: i18n.t(`${lc}none`),
    },
};
